export default class AccessibleTabs {
	el: HTMLElement;
	tabs: HTMLElement[];
	panels: HTMLElement[];
	currentTabIndex: number = -1;

	constructor(el: HTMLElement) {
		this.el = el;
		this.tabs = Array.from(el.querySelectorAll('[role="tab"]'));
		this.panels = [];

		this.tabs.forEach((tab, index) => {
			let panel;
			const panelId = tab.getAttribute('aria-controls');

			if (panelId) {
				panel = document.getElementById(panelId);
			}

			if (panel) {
				this.panels.push(panel);
			}

			tab.tabIndex = -1;

			tab.addEventListener('click', this.tabClickHandler.bind(this));
			tab.addEventListener('keydown', this.keydownHandler.bind(this));

			if (tab.getAttribute('aria-selected') === 'true') {
				this.currentTabIndex = index;
			}
		});

		if (this.currentTabIndex === -1) {
			this.currentTabIndex = 0;
		}

		this.render();
	}

	tabClickHandler({ target: tab }: MouseEvent) {
		const tabIndex = this.tabs.indexOf(<HTMLElement>tab);

		this.currentTabIndex = tabIndex;

		this.render();
	}

	keydownHandler(event: KeyboardEvent) {
		const { target: tab, key } = event;

		let nextTabIndex: number | undefined;

		const tabIndex = this.tabs.indexOf(<HTMLElement>tab);
		const lastTabIndex = this.tabs.length - 1;

		switch (key) {
			case 'ArrowLeft':
				nextTabIndex = tabIndex === 0 ? lastTabIndex : tabIndex - 1;
				break;
			case 'ArrowRight':
				nextTabIndex = tabIndex === lastTabIndex ? 0 : tabIndex + 1;
				break;
			case 'Home':
				nextTabIndex = 0;
				break;
			case 'End':
				nextTabIndex = lastTabIndex;
				break;
		}

		if (typeof nextTabIndex === 'number') {
			event.preventDefault();
			event.stopPropagation();

			this.currentTabIndex = nextTabIndex;

			const tab = this.tabs[nextTabIndex];

			tab.focus();

			if (tab.nodeName === 'INPUT') {
				(<HTMLInputElement>tab).checked = true;
			}

			this.render();
		}
	}

	render() {
		const currentTab = this.tabs[this.currentTabIndex];

		this.tabs.forEach((tab) => {
			const panel = document.getElementById(
				<string>tab.getAttribute('aria-controls')
			);

			if (tab === currentTab) {
				tab.setAttribute('aria-selected', 'true');
				tab.removeAttribute('tabindex');

				if (panel) {
					panel.hidden = false;
				}
			} else {
				tab.setAttribute('aria-selected', 'false');
				tab.tabIndex = -1;

				if (panel) {
					panel.hidden = true;
				}
			}
		});
	}
}
